<template>
  <div>
    <CoverBg
      show-text
      title="SAS TRAININGS"
      text="At STATECS training center we empower any beginner or an advanced programmer both with
       knowledge & motivation"
    />
    <b-container class="main-container content-padding-t-b-100">
      <Paragraph
        :paragraph="sasTrainings.p1"
        p-item-distance
        class="m-b-100"
      />
      <div class="text-center">
        <img
          :src="sasTrainings.imgSrc"
          alt="Fluid image"
          class="m-b-100"
        >
      </div>
      <Paragraph
        :paragraph="sasTrainings.p2"
        p-distance
      />
      <Paragraph
        :paragraph="sasTrainings.p3"
      />
      <div class="d-flex justify-content-end mt-5">
        <b-btn
          class="btn-main-bg-blue btn-main-bg-blue-bordered"
          @click="redirectToApplyPage"
        >
          Apply
        </b-btn>
      </div>
    </b-container>
  </div>
</template>

<script>
import CoverBg from '@/components/CoverBg';
import sasTrainings from '@/constants/sasTrainings';
import Paragraph from '@/components/Paragraph';
import { R_APPLY_SAS } from '@/router/routes';
import { SAS_TRAINING } from '@/constants/applyFormTypes';
import { scrollToTop } from '@/helpers/helpers';

export default {
  name: 'SASTrainings',
  components: { CoverBg, Paragraph },
  data() {
    return {
      sasTrainings,
    };
  },
  methods: {
    redirectToApplyPage() {
      scrollToTop();
      this.$router.push({
        name: R_APPLY_SAS,
        query: {
          type: SAS_TRAINING,
        },
      });
    },
  },
};
</script>
